import type { InitOptions } from 'i18next';
import type { LangCode } from './locales-config';

import i18next from 'i18next';
import { getStorage } from 'minimal-shared/utils';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next, I18nextProvider as Provider } from 'react-i18next';

import { i18nOptions, fallbackLng, storageConfig, i18nResourceLoader } from './locales-config';

// ----------------------------------------------------------------------

const i18nextLng = getStorage(
  storageConfig.localStorage.key,
  storageConfig.localStorage.autoDetection ? undefined : fallbackLng
) as LangCode;

/**
 * Initialize i18next
 */
const initOptions: InitOptions = {
  ...i18nOptions(i18nextLng),
  detection: { caches: ['localStorage'] },
  // GMN-3252: React already escapes text children, so i18next's own escaping is
  // redundant AND harmful — it turns an interpolated value into entities that
  // React then renders literally. A timezone came out as "Asia&#x2F;Jerusalem";
  // "Verified at {{date}}" has the same latent problem for any slash-bearing
  // date. This is the setting react-i18next documents for exactly this reason.
  // Safe here: the only two dangerouslySetInnerHTML sites in this app
  // (layouts/dashboard/hooks/useChatlio.tsx — a hardcoded literal tag — and
  // layouts/components/notifications-drawer/notification-item.tsx — API content)
  // contain no t() calls, so no translated string reaches an HTML sink.
  // Do not re-enable without re-checking that.
  interpolation: { escapeValue: false },
};

i18next.use(LanguageDetector).use(initReactI18next).use(i18nResourceLoader).init(initOptions);

// ----------------------------------------------------------------------

type I18nProviderProps = {
  children: React.ReactNode;
};

export function I18nProvider({ children }: I18nProviderProps) {
  return <Provider i18n={i18next}>{children}</Provider>;
}
